module.exports = __webpack_public_path__ + "static/media/tlyfe-web.8af1a542.png";